export const loadItem = (storageKey, defaultValue) => {
  try {
    const item = localStorage.getItem(storageKey);
    if (item === null) {
      return defaultValue;
    }
    return JSON.parse(item);
  } catch (err) {
    return defaultValue;
  }
};

export const saveItem = (storageKey, data) => {
  try {
    const stringData = JSON.stringify(data);
    localStorage.setItem(storageKey, stringData);
  } catch (err) {
    console.error(err);
  }
};



// WEBPACK FOOTER //
// ./src/utilities/localStorage.js